/**
 * @desc AJS compliant router function to handle migration routes
 * @param {angular.$stateProvider} $stateProvider - Angular stateprovider to handle states
 * @return {void}
 */

import template from './covid-19.template.html'

export function Covid19Router($stateProvider) {
  $stateProvider
    .state('app.ops-support-covid-19', {
      url: '/ops-support/covid-19',
      templateUrl: template,
    })
}



// WEBPACK FOOTER //
// ./src/app/ops-support/covid-19/covid-19.router.js